import React, { useState, useCallback } from 'react';
import { Page, Text, View, Document, Image, StyleSheet } from "@react-pdf/renderer";
import * as App from "../../model/App";

interface ITrademarkPdfProps { 
    trademark?: App.Data.App.ITrademark;
    clients?: { [key: string]: App.Data.App.IClient };
}

const styles = StyleSheet.create({
    page: {
      flexDirection: 'row',
      backgroundColor: 'white',
      marginLeft: "auto",
      marginRight: "auto",
      border: "1px solid black",
    },

    outerView:      { display: "flex", margin: 20, width: "100%" },

    logoContainer:  { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center", width: "100%" },
    logo:           { fontSize: "108px", fontStyle: "bold", fontWeight: "heavy", color: "red" },
    sublogo:        { fontSize: "24px", fontStyle: "bold", color: "red" },

    row:            { flexDirection: 'row', alignItems: 'center', height: 24 },
    rowEven:        { backgroundColor: "white" },
    rowOdd:         { backgroundColor: "#eeeeee" },
    innerRow:       { display: "flex", flexDirection: "row", justifyContent: "space-between", width: "100%", marginLeft: 10, marginRight: 10 },
    rowHeader:      { fontSize: "12px", fontWeight: "heavy" },
    rowValue:       { fontSize: "12px" },

    space:          { paddingTop: "30px" }
});

export default function TrademarkPdf(props: ITrademarkPdfProps) {

    // If no trademark...
    if (!props.trademark) { return null; }

    // Re-use the CSV format...
    const arrData: { [key: string]: string }[] = App.Data.App.TrademarkUtils.toCsvFormat([props.trademark], props.clients ?? {});
    if (!arrData || arrData.length === 0) { return null; }
    const data = arrData[0];

    // Specify which data we want...
    const renewalDue = props.trademark.deadlines.find(d => d.title === "RENEWAL DUE");
    const firstDeclarationOfUse = props.trademark.deadlines.find(d => d.title === "FIRST DECLARATION OF USE EXPIRES");
    const pdfData: { [key: string]: string } = {
        "Client":                           data["Client"],
        "Title":                            data["Title"],
        "Application Number":               data["Application Number"],
        "Filing Date":                      data["Filing Date"],
        "Class Number":                     data["Class Number"],
        "Registration Number":              data["Registration Number"],
        "Registration Date":                data["Registration Date"],
        "Expiration Date":                  data["Expiration Date"],
        "Owners":                           data["Owners"],
        "Attorney of Record":               data["Attorney of Record"],
        "Renewal Due":                      (renewalDue && renewalDue.dueDate) ? (new Date(renewalDue.dueDate)).toLocaleDateString("en-US") : "",
        "First Declaration of Use Expires": (firstDeclarationOfUse && firstDeclarationOfUse.dueDate) ? (new Date(firstDeclarationOfUse.dueDate)).toLocaleDateString("en-US") : "",
        "Description of Goods or Services": data["Description of Goods or Services"]
    }

    
    
    const MAX_CHARS = 60;

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.outerView}>
                    <View style={styles.logoContainer}>
                        <Text style={styles.logo}>æ</Text>
                        <Text style={styles.sublogo}>Aarón Estrada Legal</Text>
                        <Text style={{ fontSize: "10px" }}>Insurgentes Sur 730 Piso 1, Col. Del Valle, Benito Juarez, 03100</Text>
                        <Text style={{ fontSize: "10px" }}>Ciudad de México</Text>
                    </View>
                    <View style={styles.space} />

                    {
                        Object.keys(pdfData).map((key: string, index: number) => {
                            if (key === "Description of Goods or Services") { return null; }

                            const value = pdfData[key];
                            return (
                                <View key={`row_${index}`} style={[styles.row, (index % 2 === 0) ? styles.rowEven : styles.rowOdd]}>
                                    <View style={styles.innerRow}>
                                        <Text style={styles.rowHeader}>{key}</Text>
                                        <Text style={styles.rowValue}>{value.slice(0, MAX_CHARS)}</Text>
                                    </View>
                                </View>
                            );
                        })
                    }

                    <View style={styles.space} />
                    <Text style={styles.rowHeader}>Description of Goods or Services:</Text>
                    <Text style={styles.rowValue}>{pdfData["Description of Goods or Services"]}</Text>
                </View>
            </Page>
        </Document>
    );
}